import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { IKeywordEntry } from "../../types";

interface KeywordsTableProps {
  keywords: IKeywordEntry[];
}

const INITIAL_ROWS = 4;

function PositionChip({ position }: { position: number }) {
  const color =
    position <= 5 ? "success" : position <= 10 ? "warning" : "error";
  return <Chip label={`#${position}`} color={color} size="small" />;
}

export function KeywordsTable({ keywords }: KeywordsTableProps) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? keywords : keywords.slice(0, INITIAL_ROWS);

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          Palavras-chave
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell align="right">Volume</TableCell>
              <TableCell align="center">Tendência</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visible.map((kw) => (
              <TableRow key={kw.query}>
                <TableCell>{kw.query}</TableCell>
                <TableCell align="right">{kw.clicks.toLocaleString("pt-BR")}</TableCell>
                <TableCell align="center">
                  <PositionChip position={Math.round(kw.position)} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {keywords.length > INITIAL_ROWS && (
          <Box mt={1} display="flex" justifyContent="flex-end">
            <Button size="small" onClick={() => setExpanded((v) => !v)}>
              {expanded ? "Ver menos" : "Ver mais"}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
